import { render } from "./Output.vue?vue&type=template&id=1d987337&scoped=true"
import script from "./Output.vue?vue&type=script&lang=ts"
export * from "./Output.vue?vue&type=script&lang=ts"

import "./Output.vue?vue&type=style&index=0&id=1d987337&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1d987337"

export default script